var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      attrs: {
        cardClass:
          "border border-gray-300 shadow-sm hover:border-blue groupCard",
      },
    },
    [
      _c("div", { staticClass: "flex w-full flex-col" }, [
        _c(
          "div",
          { staticClass: "flex flex-col flex-initial" },
          [
            _c("CircleWithInitials", {
              attrs: { title: _vm.group.name, large: true },
            }),
            _c(
              "RouterLink",
              {
                staticClass: "flex items-center",
                attrs: {
                  to: {
                    name: _vm.groupDetailsRouteName,
                    params: { id: _vm.groupId },
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-row" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "blueLabelActive truncate font-Outfit text-lg font-medium mr-2 mt-3",
                      },
                      [_vm._v(" " + _vm._s(_vm.groupName) + " ")]
                    ),
                    _vm.archived
                      ? _c("CardInfoChip", {
                          staticClass: "ml-2 mt-3",
                          attrs: { message: "Archived", gray: "" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-6",
              },
              [
                _c("LocationIconNew", { staticClass: "pr-2 w-auto h-auto" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.groupLocation ? _vm.groupLocation : "n/a") +
                    " "
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "xl:flex w-full" }, [
          _c("div", { staticClass: "flex flex-col flex-grow" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex justify-flex-start items-start text-storm-gray text-sm font-medium pb-2 h-10",
              },
              [
                _c("ResouceIcon", { staticClass: "pr-2 w-auto h-4" }),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-primary-black font-400 text-sm pr-2 nameWidth",
                  },
                  [_vm._v("Resources")]
                ),
                _c("ItemChipsWithMore", {
                  attrs: {
                    items: _vm.groupContractors,
                    limit: 1,
                    adjustPadding: "true",
                    navigateTo: _vm.navigateToDetails,
                    alignmentClass: "items-flex-start",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ itemsToRender }) {
                        return _vm._l(itemsToRender, function (item) {
                          return _c(
                            "EmployeeRemovedFromCompanyTooltip",
                            {
                              key: item.id,
                              attrs: { disabled: !item.deleted },
                            },
                            [
                              _c("ItemChip", {
                                attrs: {
                                  itemId: item.id,
                                  itemName: item.name,
                                  itemRole: item.role,
                                  itemExtra: item.extra,
                                  textClasses: "maxWidth sm:truncate",
                                  adjustPadding: "true",
                                  avatar: item.avatar,
                                  routeParams: item.routeParams,
                                  removed: item.deleted,
                                  routeName:
                                    _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                  isPerson: "",
                                },
                              }),
                            ],
                            1
                          )
                        })
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex justify-flex-start items-start text-storm-gray text-sm font-medium pb-1.5",
              },
              [
                _c("ProjectsIcon", { staticClass: "pr-2 w-auto h-4" }),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-primary-black font-400 text-sm pr-2 nameWidth",
                  },
                  [_vm._v("Clients")]
                ),
                _c("ItemChipsWithMore", {
                  attrs: {
                    items: _vm.groupProjects,
                    textClasses: "remvoePadding maxWidth sm:truncate",
                    limit: 1,
                    adjustPadding: "true",
                    navigateTo: _vm.navigateToDetails,
                    routeName: _vm.routes.PROJECT_ACTIVITY,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex justify-flex-start items-start text-storm-gray text-sm font-medium mb-3",
              },
              [
                _c("PostingIcon", { staticClass: "pr-2 w-auto h-4" }),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-primary-black font-400 text-sm pr-2 nameWidth",
                  },
                  [_vm._v("Postings")]
                ),
                _c("p", [_vm._v(_vm._s(_vm.groupPostings.length))]),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass:
              "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex gap-1 w-full skills-footer items-center py-4",
              },
              [
                _vm._v(" Skill: "),
                _vm.groupSkills.length > 0
                  ? _c(
                      "div",
                      { staticClass: "flex flex-row gap-1 items-center" },
                      [
                        _vm._l(_vm.skills.slice(0, 3), function (skill) {
                          return _c(
                            "div",
                            {
                              key: skill.skill.name,
                              staticClass: "skills-chip",
                            },
                            [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                          )
                        }),
                        _vm.groupSkills.length > 3
                          ? _c("div", [
                              _c("div", { staticClass: "skills-chip-plus" }, [
                                _vm._v(
                                  " +" +
                                    _vm._s(_vm.groupSkills.length - 3) +
                                    " "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  : _c("div", [_vm._v("n/a")]),
              ]
            ),
          ]
        ),
      ]),
      !_vm.archived
        ? _c(
            "div",
            {
              staticClass:
                "flex w-full flex-col gap-3 pt-4 adjustFlexWidth items-center border-t border-gray-200",
            },
            [
              _c("GroupConversationProvider", {
                staticClass: "flex items-center w-full mt-0.5 ml-2",
                attrs: {
                  contractors: _vm.contractors,
                  managers: _vm.managers,
                  currentUserRole: _vm.currentUser.role,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({
                        participantsExist,
                        groupConversationUsers,
                      }) {
                        return [
                          participantsExist
                            ? _c("UiButton", {
                                staticClass: "adjustFlexWidth",
                                attrs: {
                                  variant: "black",
                                  size: "no",
                                  buttonText: "Message",
                                  buttonClasses: "customButtonCardProject",
                                  fullWidth: true,
                                },
                                on: { click: _vm.groupMessage },
                              })
                            : _vm._e(),
                          _c("CreateGroupConversationModal", {
                            attrs: {
                              companyId: _vm.companyId,
                              currentUserId: _vm.currentUser.id,
                              groupConversationUsers: groupConversationUsers,
                              projectTitle: _vm.groupName,
                            },
                            model: {
                              value: _vm.newConversationDialog,
                              callback: function ($$v) {
                                _vm.newConversationDialog = $$v
                              },
                              expression: "newConversationDialog",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  831246700
                ),
              }),
              _c("UiButton", {
                staticClass: "w-full",
                attrs: {
                  variant: "outline",
                  size: "no",
                  buttonText: "Edit",
                  buttonClasses: "customButtonCardProject",
                  fullWidth: true,
                },
                on: { click: _vm.handleEditClick },
              }),
              _vm.dialog
                ? _c("GroupModal", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      dialog: _vm.dialog,
                      data: _vm.group,
                      companyId: _vm.companyId,
                    },
                    on: {
                      refetch: function ($event) {
                        return _vm.$emit("refetch")
                      },
                      close: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }